import React, { useContext } from 'react'
import { CartContext } from '../../Context/CartContext.jsx'
import { VscTrash } from 'react-icons/vsc'
import { Link } from 'react-router-dom'
import { FaStar } from 'react-icons/fa'
import emptyWish from "./../../assets/empty-state-cart.svg";
import { AiOutlineMinus, AiOutlinePlus, AiOutlineShopping } from 'react-icons/ai'
import { Helmet, HelmetProvider } from "react-helmet-async";

const Cart = () => {
    const { cartItems, removeProductFromCart, decreaseQuantity, increaseQuantity, getQuantity } = useContext(CartContext)

    const arrayOfQuantities = cartItems.products?.map((item) => item.quantity)


    function calcTotalQuantity() {
        return arrayOfQuantities?.reduce((sum, quantity) => sum + quantity)
    }

    return (
        <HelmetProvider>
            <Helmet>
                <title> FreshCart | Cart</title>
            </Helmet>
            {cartItems && cartItems.products?.length > 0 ?
                <>
                    <div className="w-full text-center my-4">
                        <h2 className="text-3xl py-2 font-medium">My Cart</h2>
                    </div>
                    <div className="flex gap-4 flex-col lg:flex-row container">
                        <div className="flex flex-col gap-y-5 justify-center items-center lg:w-3/4 px-5 lg:px-0">
                            {cartItems.products.map((item, i) => (
                                <div key={i} className="item flex-col sm:flex-row flex border shadow w-full relative">
                                    <div className="img-box sm:w-1/5 p-3">
                                        <Link to={`/products/${item.productId._id}`}>
                                            <img className="m-auto w-full" src={item.productId.mainImage?.path} alt="Product_Image" /></Link>
                                    </div>
                                    <div className="body details p-2 py-5 sm:w-3/5">
                                        <h2 className="text-base sm:text-lg font-medium">{`${item.productId.name?.charAt(0).toUpperCase() + item.productId.name?.slice(1)}`}</h2>
                                        <div className="flex gap-2 my-2">
                                            <div className='flex items-center gap-1.5 bg-gray-50 shadow-sm rounded py-1 px-3 w-max'>
                                                <FaStar className=" text-yellow-400" />
                                                <span>{item.productId.AvgRate}</span>
                                            </div>
                                            <div className='flex items-center bg-gray-50 shadow-sm rounded py-1 px-3 w-max'>
                                                <span>{item.productId.ratingCount} <span className="text-sm mx-1">Ratings</span></span>
                                            </div>
                                        </div>
                                        <div className="my-5">
                                            <p className="text-2xl font-medium">EGP {item.productId.priceAfterDiscount?.toFixed(2)}</p>
                                        </div>
                                    </div>
                                    <div className="py-2 absolute end-2">
                                        <button onClick={() => removeProductFromCart(item.productId._id)} className='flex items-center justify-center gap-1 p-2 border border-red-600 text-red-600 hover:bg-red-600 hover:text-white rounded group duration-300'>
                                            <VscTrash className='group-hover:animate-bounce' />
                                        </button>
                                    </div>
                                    <div className="py-5 sm:py-0 sm:w-1/5 flex justify-center items-center gap-1">
                                        <button onClick={() => decreaseQuantity(item.quantity, item.productId._id)} className=" w-9 h-9 rounded bg-gray-300 hover:bg-gray-200 duration-100 flex items-center justify-center" ><AiOutlineMinus /></button>
                                        <input onChange={getQuantity} type="text" min="1" max={item.productId.stock} className='w-1/3 p-2 border focus:outline-none text-neutral-600 rounded text-center' value={item.quantity} />
                                        <button onClick={() => increaseQuantity(item.quantity, item.productId.stock, item.productId._id)} className="w-9 h-9 rounded bg-gray-300 hover:bg-gray-200 duration-100 flex items-center justify-center" ><AiOutlinePlus /></button>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="lg:w-1/4 px-5 lg:px-0 relative">
                            <div className="cart-summary border p-2 h-fit w-full">
                                <h2 className="text-2xl font-medium py-2 text-center">Summary</h2>
                                <hr />
                                <div className="flex flex-col py-4 px-1 gap-y-4">
                                    <p className="text-base font-medium">SubTotal : <span className="text-amber-600 text-xl font-serif">{cartItems.totalPrice?.toFixed(2)}</span> EGP</p>
                                    <p className="text-base font-medium">Quantity : <span className="text-amber-600 text-xl font-serif">{calcTotalQuantity()}</span> Item</p>
                                </div>
                                <hr />
                                <div className="btn py-3">
                                    <Link to="/checkout" className="flex items-center justify-center gap-1 p-2 border border-amber-600 text-amber-600 hover:bg-amber-600 hover:text-white rounded group duration-300 uppercase w-full">
                                        <AiOutlineShopping size={16} className='group-hover:animate-bounce' />
                                        Checkout
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </> : <div className='container min-h-96 '>
                    <div className="flex flex-wrap gap-4 h-full flex-col justify-center items-center p-3 text-center">
                        <div className="img-box mt-10">
                            <img src={emptyWish} alt="" />
                        </div>
                        <p className="text-2xl font-medium">Your Cart is Empty</p>
                        <p className="text-slate-500 text-base">Explore More and ShortList some items</p>
                        <Link to="/" className='bg-green-500 text-slate-50 rounded py-2 px-6 text-sm uppercase font-bold  hover:bg-green-700'>Start Shopping</Link>
                    </div>
                </div>}
        </HelmetProvider>
    )
}

export default Cart